<template>
	<div class="ui-if">
		<!-- Показываем анимацию для label, если что-то ввели в input -->
		<div v-if="text !== EMPTY" class="ui-if__anim">
			{{ label }}
		</div>

		<div class="ui-if__elm" @click="onFocus">
			<IconSearch
				v-if="isShowIcon"
				class="ui-if__elm-icon"
				color="rgb(119, 121, 124)"
				width="16"
				height="16"
			/>
			<div class="ui-if__elm-search">
				<input
					ref="searchInput"
					@input="search"
					type="text"
					class="ui-if__elm-search-input"
					:placeholder="label"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconSearch from "@/components/icons/IconSearch.vue";

@Options({
	components: { IconSearch },
	props: {
		label: { type: String, default: "" },
		isShowIcon: { type: Boolean, default: true },
	},
})
export default class UiInputFilter extends Vue {
	public EMPTY = "";
	public text = "";

	/**
	 * Устанавливаем курсор в область поля ввода
	 */
	public onFocus() {
		const searchInput = this.$refs.searchInput as HTMLInputElement;
		searchInput.focus();
	}

	/**
	 * Обрабртка события input
	 * @param event
	 */
	public search(event: Event) {
		this.text = (event.target as HTMLInputElement).value;
		this.$emit("filter", this.text);
	}
}
</script>

<style scoped lang="scss">
.ui-if {
	position: relative;

	&__anim {
		position: absolute;
		top: -15px;
		font-size: 12px;
		color: rgb(51, 51, 51);

		// Анимация
		animation-duration: 0.4s;
		animation-name: appearance-animation-search;
	}

	&__elm {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	&__elm-icon {
		margin-right: 10px;
	}

	&__elm-search {
		border: 1px solid rgb(252, 252, 252);
		border-radius: 12px;
		background-color: rgb(252, 252, 252);
		opacity: 1;
		width: 100%;
	}

	&__elm-search-input {
		background-color: rgb(252, 252, 252);
		border: 1px solid rgb(252, 252, 252);
		font-size: 16px;
		width: 100%;
	}

	&__elm-search-input:focus {
		outline-color: rgb(252, 252, 252);
		outline-style: solid;
	}
}

@keyframes appearance-animation-search {
	0% {
		opacity: 0;
		transform: translate(0px, 10px);
		left: 0;
		right: 0;
	}
	100% {
		opacity: 1;
		transform: translate(0, 0);
		left: 0;
		right: 0;
	}
}
</style>
